module.exports = __webpack_public_path__ + "static/media/Facturacion.02434b37.svg";